<template lang="pug">
  .component-federation-controller
    .row
      .columns.small-6.large-12
        .row.column
          router-tab-headers(:tabs="tabs", :id="'federation-vehicles'", :activeIndex="0", :deepLink="true")
            router-view
</template>

<script>
  import RouterTabHeaders from '../../../components/structure/foundation/RouterTabHeaders'

  export default {
    name: 'Federation',
    components: {RouterTabHeaders},
    data() {
      return {
        tabs: [
          {
            headerName: 'Vehicles',
            name: 'federation-vehicles',
            pathName: 'vehicles'
          },
          {
            headerName: 'Clients',
            name: 'federation-clients',
            pathName: 'clients'
          },
            {
            headerName: 'Parking Groups',
            name: 'federation-parking-groups',
            pathName: 'parking-groups'
          },
          {
            headerName: 'Configuration',
            name: 'federation-config',
            pathName: 'federation-config'
          },
        ],
      }
    },

    props: ['item'],
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Federation.vue?6e01c724